      uniform sampler2D uVideoTexture;
      uniform sampler2D uDiffuseMap;
      uniform vec3 uProjectorPosition;
      uniform vec3 uProjectorDirection;
      uniform mat4 uProjectorMatrix;
      uniform float uProjectorFOV;
      uniform float uProjectorAspect;
      uniform vec3 uBaseColor;
      uniform float uProjectionIntensity;
      uniform float uVignette;
      uniform float uBlendFactor;
      uniform float uMinZDistance;
      uniform float uFadeHeight;
      uniform float uTerrainHeight;
      
      varying vec3 vWorldPos;
      varying vec2 vUv;
      varying vec3 vNormalVector;
      varying float vIsFrontFacing;
      
void main() {
  // Sample the diffuse texture
  vec4 diffuseC = texture2D(uDiffuseMap, vUv);
  vec3 finalColor = diffuseC.rgb; // Initialize with diffuse color by default


  float fadeFactor = smoothstep(uTerrainHeight, uTerrainHeight + uFadeHeight, vWorldPos.y);

  // We explicitly designate the positive normal direction as the side for projection
  // For a standard plane, this is the side with normal (0,0,1)
  bool isProjectionSide = vIsFrontFacing > 0.0; // Only project on front side
  
  if (isProjectionSide) {
    // Direction from projector to this fragment
    vec3 projToFrag = normalize(vWorldPos - uProjectorPosition);
    
    // Project the point onto the projector's viewing plane
    vec4 projectorViewPosition = uProjectorMatrix * vec4(vWorldPos, 1.0);
    
    // If the fragment is in front of the projector, show the projection
    if (projectorViewPosition.z > uMinZDistance) {
      // Calculate UV coordinates for projection
      //float distance = length(vWorldPos - uProjectorPosition);
      //float attenuation = 1.0 / (1.0 + 0.1 * distance + 0.0 * distance);
      
      // Convert view position to NDC space, then to UV coordinates
      vec2 projUV = projectorViewPosition.xy / projectorViewPosition.z;
      projUV = projUV * 0.5 + 0.5;
      
      // Check if within projection bounds (0 to 1)
      if (projUV.x >= 0.0 && projUV.x <= 1.0 && projUV.y >= 0.0 && projUV.y <= 1.0) {
        // Sample video texture with projected coordinates
        vec4 projectedColor = texture2D(uVideoTexture, projUV);
        
        // Add vignette effect for old-school projector look
        //float vignetteAmount = 1.0 - uVignette * length(projUV - 0.5) * 2.0;
        //vignetteAmount = clamp(vignetteAmount, 0.0, 1.0);
        
        // Add subtle noise for film grain effect
        //float noise = fract(sin(dot(projUV, vec2(12.9898, 78.233))) * 43758.5453) * 0.09;
        
        // Calculate projection color with effects
        vec3 projColor = projectedColor.rgb * uProjectionIntensity;
        //projColor += noise;
        
        // Screen blend mode (brightens the image)
        vec3 blendedColor = 1.0 - (1.0 - diffuseC.rgb) * (1.0 - projColor);
        
        // Final color is a blend between the diffuse and the blended projection
        finalColor = mix(diffuseC.rgb , blendedColor, uBlendFactor);
        finalColor *= 2.5;
        //finalColor *= fadeFactor;
      }
    }
  }
  
  // Always output the final color, whether it's been projected on or not
  csm_DiffuseColor = vec4(finalColor, 1.0) * fadeFactor;
}